import React from 'react';
import footerbg from '../assets/footerbg.svg';
import ellipse from '../assets/ellipse.svg';
import './footer.css';

const Footer = () => {
  return (
    <>
    <div className='duf__footer section__padding' id='contact'>
       <div className="duf__footer-image">
          <img src={footerbg} alt="footerbg" />
        </div>
      <div className="duf__Footer-content">
        
      <h4>Contact Us</h4>
      <p>If you have any things want to discuss, feel free to reach us, we are in Singapore, grab a coffee is just a small issue. Or you can use the below email.</p>
      <span className='footercard'>
        <img src={ellipse} alt="ellipse" />
        <a href="mailto:enquiry@duftee.com" className="p-text">duftee.sg@gmail.com</a>
      </span>
      </div>
    </div>
    <div className="duf__footer-copyright">
        <p>Copyright © 2021 - 2022 Duftee LLC All rights reserved.</p>
    </div>
    </>
  )
}

export default Footer;
